import React, { useState } from 'react';
import { ReactComponent as CloseIcon } from '../../svg/close.svg';
import { ReactComponent as MinimizeIcon } from '../../svg/minimize.svg';
import { ReactComponent as MaximizeIcon } from '../../svg/maximize.svg';
import {
  ContentContainer,
  FloatingHeader,
  HeaderLeft,
  FloatingTitle,
  Buttons,
  IconButton,
  ResetButton,
  HoverResizeHandle,
} from './styles';
import chatbotActions from 'state/chatbot/actions';
import { useDispatch } from 'react-redux';
import useChatbot from 'hooks/useChatbot';
import utils from 'utils';

interface FloatingProps {
  startResize: (e: React.MouseEvent) => void;
  onHeaderMouseDown?: (e: React.MouseEvent) => void;
  onHeaderHoverChange?: (isHovered: boolean) => void;
  renderContent: () => React.ReactNode;
  resetWidget?: () => void;
  isInitialState?: boolean;
}

const Floating: React.FC<FloatingProps> = ({
  startResize,
  onHeaderMouseDown,
  onHeaderHoverChange,
  renderContent,
  resetWidget,
  isInitialState,
}) => {
  const dispatch = useDispatch();
  const [isHeaderHovered, setIsHeaderHovered] = useState(false);
  const { close } = useChatbot();
  const t = utils.intl.useTranslator();

  return (
    <ContentContainer>
      <HoverResizeHandle onMouseDown={startResize} isHovered={isHeaderHovered} />

      <FloatingHeader
        onMouseDown={onHeaderMouseDown}
        onMouseEnter={() => {
          setIsHeaderHovered(true);
          if (onHeaderHoverChange) {
            onHeaderHoverChange(true);
          }
        }}
        onMouseLeave={() => {
          setIsHeaderHovered(false);
          if (onHeaderHoverChange) {
            onHeaderHoverChange(false);
          }
        }}
      >
        <HeaderLeft>
          <FloatingTitle>{utils.app.textTranslated('aiHelper', t, 'AI Helper')}</FloatingTitle>
          {!isInitialState && isHeaderHovered && resetWidget && (
            <ResetButton
              onClick={resetWidget}
              title={utils.app.textTranslated('resetButtonTitle', t, 'Reset to initial position')}
            >
              {utils.app.textTranslated('reset', t, 'Reset')}
            </ResetButton>
          )}
        </HeaderLeft>
        <Buttons>
          <IconButton onClick={() => dispatch(chatbotActions.setMinimized(true))}>
            <MinimizeIcon width={16} height={16} />
          </IconButton>
          <IconButton
            onClick={() => dispatch(chatbotActions.setDisplayMode('embedded'))}
            title={utils.app.textTranslated('switchToFullMode', t, 'Switch to full mode')}
          >
            <MaximizeIcon width={16} height={16} />
          </IconButton>
          {close && (
            <IconButton onClick={close}>
              <CloseIcon width={16} height={16} />
            </IconButton>
          )}
        </Buttons>
      </FloatingHeader>
      {renderContent()}
    </ContentContainer>
  );
};

export default Floating;
